/**
 * ServicePlaceholderTabs — 4 simple "no data yet" placeholder views.
 * Extracted from ManagePlatform.js
 */
import { Briefcase, FileCheck, Languages, Wallet } from 'lucide-react';

const STUBS = {
  'service-company-setup': {
    icon: Briefcase,
    color: 'emerald-500',
    title: 'طلبات تأسيس الشركات',
    emptyMsg: 'ستظهر هنا طلبات تأسيس الشركات الجديدة',
  },
  'service-documents': {
    icon: FileCheck,
    color: 'orange-500',
    title: 'طلبات الطباعة وتخليص المستندات',
    emptyMsg: 'ستظهر هنا طلبات الطباعة وتخليص المستندات',
  },
  'service-translation': {
    icon: Languages,
    color: 'sky-500',
    title: 'طلبات خدمات الترجمة القانونية',
    emptyMsg: 'ستظهر هنا طلبات الترجمة القانونية',
  },
  'service-bill-payment': {
    icon: Wallet,
    color: 'teal-500',
    title: 'طلبات خدمات دفع الفواتير',
    emptyMsg: 'ستظهر هنا طلبات دفع الفواتير (Tamara & Tabby)',
  },
};

export default function ServicePlaceholderTab({ tabKey }) {
  const stub = STUBS[tabKey];
  if (!stub) return null;
  const Icon = stub.icon;
  // Use full class names so Tailwind picks them up
  const colorClassMap = {
    'emerald-500': 'text-emerald-500',
    'orange-500': 'text-orange-500',
    'sky-500': 'text-sky-500',
    'teal-500': 'text-teal-500',
  };
  const colorClass = colorClassMap[stub.color];

  return (
    <div data-testid={`service-stub-${tabKey}`}>
      <h2 className="text-xl font-bold text-white mb-5 flex items-center gap-3">
        <Icon className={`h-6 w-6 ${colorClass}`} />
        {stub.title}
      </h2>
      <div className="text-center py-16 text-[#808080]">
        <Icon className={`h-12 w-12 mx-auto mb-3 opacity-50 ${colorClass}`} />
        <p>لا توجد طلبات حالياً</p>
        <p className="text-sm text-[#606060] mt-2">{stub.emptyMsg}</p>
      </div>
    </div>
  );
}
